import {useEffect, useState} from "react";
import GoToSubscribeAlert from "../../common/alert/GoToSubscribeAlert";
import GoogleLoginHandler from "../../common/hooks/GoogleLoginHandler";
import PromoBanner from "../promoBanner";
import BottomTab from "../../common/hooks/BottomTab";
import {tabLink} from "../../common/constant/tablink";
import InfluencerApproval from "./InfluencerApproval";
import {drawerWidth} from "../../common/constants";
import Header3 from "../../common/header/Header3";
import LoginPopUp from "../loginpopup";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {Drawer, IconButton, useMediaQuery} from "@mui/material";
import {Helmet} from "react-helmet";
import UserAvatar from "../userAvatar";
import {ReactComponent as NotificationIcon} from "../../pages/account/profile/profile_icon/notification-icon.svg";
import json2mq from "json2mq";
import {getAlertCountAPI} from "../../apihelper/profile";
import SidebarMenuList from "../../includes/sidebarMenuList";

export const InfluencerPage = (props) => {
    const {window1} = props;
    const [goToSubscribeAlertOpen, setGoToSubscribeAlertOpen] = useState(false);
    const [subscriptionText, setSubscriptionText] = useState("");
    const [unreadAlerts, setUnreadAlerts] = useState(0);
    const [path, setPath] = useState("/");
    const [isLoginModalOpen, setLoginModalOpen] = useState(false);
    const container = window1 !== undefined ? () => window1().document.body : undefined;
    const location = useLocation();
    const [mobileOpen, setMobileOpen] = useState(false);
    const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
    const navigate = useNavigate();

    const handleModalClose = () => {
        setLoginModalOpen(false);
        navigate("/reward-section/approve-earn", {replace: true});
    };

    useEffect(() => {
        // fetch alerts count
        const fetchAlerts = async () => {
            const response = await getAlertCountAPI(userData?.user_id);
            if (response?.unread_notifications) {
                setUnreadAlerts(response?.unread_notifications);
            }
        };

        fetchAlerts();

        // Set path
        if (typeof window !== "undefined") {
            setPath(window.location.pathname);
        }
    }, []);
    const mediaQueryVar = useMediaQuery(
        json2mq({
            minWidth: 900,
        })
    );

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const TopNavigationDesktop = ({unreadAlerts}) => {
        const isActive = (href) => path === href;

        const topTabStyle = (active) => ({
            display: "flex",
            alignItems: "center",
            padding: active ? "5px 13px" : "2px 13px",
            borderRadius: "999px",
            backgroundColor: active ? "#ffffff" : "transparent",
            color: active ? "#1877F2" : "#ffffff",
            fontWeight: active ? "600" : "500",
            fontSize: "16px",
            cursor: "pointer",
            border: active ? "2px solid #ffffff" : "none",
        });

        const iconFilter = (active) =>
            active
                ? "invert(29%) sepia(98%) saturate(1502%) hue-rotate(189deg) brightness(100%) contrast(97%)"
                : "brightness(0) invert(1)";

        return (
            <div style={{padding: "20px", background: "#ffffff", divShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)"}}>
                {/* Top Navigation */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        margin: "0 auto",
                    }}
                >
                    {/* Left Tabs */}
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            backgroundColor: "#1877F2",
                            padding: "5px 5px",
                            borderRadius: "50px",
                        }}
                    >
                        {[tabLink["approve_influencer"], tabLink["influencer_ranking_prediction"], tabLink["screener"]].map(
                            (tab, index) => (
                                <Link to={tab.href} key={index} style={{textDecoration: "none", minWidth: "150px"}}>
                                    <div style={topTabStyle(isActive(tab.href))}>
                                        <img
                                            src={window?.constants?.asset_path + tab.icon}
                                            alt="icon"
                                            style={{
                                                marginRight: "6px",
                                                height: tab.icon_width || "25px",
                                                filter: iconFilter(isActive(tab.href)),
                                            }}
                                        />
                                        {!mediaQueryVar ? tab.mobile_name : tab.name}
                                    </div>
                                </Link>
                            )
                        )}
                    </div>

                    {/* Bottom Tabs */}
                    <BottomTab
                        tabs={[
                            tabLink["subscription"],
                            userData ? tabLink["my_portfolio"] : tabLink["portfolio_audit"],
                            tabLink["profile"],
                        ]}
                        handleLoginClick={handleLoginClick}
                    />

                    {/* Notification Bell */}
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-end",
                            gap: "5px",
                            marginRight: "15px",
                        }}
                    >
                        {/* Notification Bell */}
                        <div
                            onClick={() => (window.location.href = "/alerts")}
                            style={{position: "relative", cursor: "pointer"}}
                        >
                            <NotificationIcon className="notification-icon fa-2x" />
                            {/* Desktop */}
                            <div
                                style={{
                                    position: "absolute",
                                    top: "-6px",
                                    right: "2px",
                                    backgroundColor: "#c0392b",
                                    minWidth: unreadAlerts < 100 ? "20px" : "27px",
                                    height: unreadAlerts < 100 ? "20px" : "27px",
                                    borderRadius: "50%",
                                    fontSize: "11px",
                                    color: "#fff",
                                    textAlign: "center",
                                    lineHeight: "20px",
                                    fontWeight: "bold",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "0 4px",
                                }}
                            >
                                {unreadAlerts < 100 ? unreadAlerts : "99+"}
                            </div>
                        </div>

                        <UserAvatar />
                    </div>
                </div>
            </div>
        );
    };

    const TopNavigationMobile = ({unreadAlerts}) => {
        const isActive = (href) => path === href;

        const topTabStyle = (active) => ({
            display: "flex",
            alignItems: "center",
            padding: active ? "6px 6px" : "1px 6px",
            borderRadius: "999px",
            backgroundColor: active ? "#ffffff" : "transparent",
            textAlign: "left",
            color: active ? "#000" : "#ffffff",
            fontWeight: active ? "600" : "500",
            fontSize: "13px",
            cursor: "pointer",
            border: active ? "2px solid #ffffff" : "none",
        });

        const iconFilter = (active) =>
            active
                ? "invert(29%) sepia(98%) saturate(1502%) hue-rotate(189deg) brightness(100%) contrast(97%)"
                : "brightness(0) invert(1)";

        return (
            <div style={{padding: "10px 5px", background: "#ffffff", divShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)"}}>
                {/* Top Navigation */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        margin: 0,
                    }}
                >
                    {/* Left Tabs */}
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0px",
                            backgroundColor: "#1877F2",
                            padding: "5px 5px",
                            borderRadius: "50px",
                            fontSize: "13px",
                            minWidth: "200px",
                            textAlign: "center",
                            marginRight: "10px",
                        }}
                    >
                        {[tabLink["approve_influencer"], tabLink["influencer_ranking_prediction"]].map((tab, index) => (
                            <Link to={tab.href} key={index} style={{textDecoration: "none", minWidth: "130px"}}>
                                <div style={topTabStyle(isActive(tab.href))}>
                                    <img
                                        src={window?.constants?.asset_path + tab.icon}
                                        alt="icon"
                                        style={{
                                            marginRight: "6px",
                                            height: tab.icon_width || "25px",
                                            filter: iconFilter(isActive(tab.href)),
                                        }}
                                    />
                                    {tab.name}
                                </div>
                            </Link>
                        ))}
                    </div>

                    <div style={{display: "flex", alignItems: "center"}}>
                        {/* Notification Bell */}
                        <div
                            onClick={() => (window.location.href = "/alerts")}
                            style={{position: "relative", marginTop: "3px"}}
                        >
                            <NotificationIcon className="notification-icon fa-2x" />
                            {/* Mobile */}
                            <div
                                style={{
                                    position: "absolute",
                                    top: "-5px",
                                    right: "7px",
                                    backgroundColor: "#c0392b",
                                    minWidth: unreadAlerts < 100 ? "18px" : "24px",
                                    height: unreadAlerts < 100 ? "18px" : "24px",
                                    borderRadius: "50%",
                                    fontSize: "10px",
                                    color: "#fff",
                                    textAlign: "center",
                                    lineHeight: "18px",
                                    fontWeight: "bold",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "0 4px",
                                }}
                            >
                                {unreadAlerts < 100 ? unreadAlerts : "99+"}
                            </div>
                        </div>
                        <UserAvatar />

                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            edge="end"
                            onClick={handleDrawerToggle}
                            sx={{display: {sm: "none"}}}
                        >
                            <img
                                src="/images/menubar.svg"
                                alt="Menu Icon"
                                style={{
                                    width: "24px",
                                    height: "24px",
                                    marginRight: "10px",
                                    marginTop: "10px",
                                }}
                            />
                        </IconButton>
                    </div>
                </div>

                {/* Bottom Tabs */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        gap: "10px",
                        marginTop: "25px",
                        marginRight: "10px",
                    }}
                >
                    <BottomTab
                        tabs={[
                            tabLink["subscription"],
                            userData ? tabLink["my_portfolio"] : tabLink["portfolio_audit"],
                            tabLink["profile"],
                        ]}
                        handleLoginClick={handleLoginClick}
                    />
                </div>
            </div>
        );
    };

    const handleLoginClick = () => {
        const originalUrl = window.location.pathname + window.location.search;
        sessionStorage.setItem("originalUrl", originalUrl);

        fetch(`${process.env.REACT_APP_API_URL}/initiategooglelogin?originalUrl=${encodeURIComponent(originalUrl)}`)
        .then((res) => res.json())
        .then((res) => {
            if (res.google_url) {
                window.location.replace(res.google_url); // Redirect to Google login
            } else {
                console.error("Failed to get Google login URL");
            }
        })
        .catch((err) => console.error("Error initiating login:", err));
    };

    return (
        <div
            style={{
                width: "100vw",
                maxWidth: "100%",
                overflowX: "hidden",
                minHeight: "100vh",
                backgroundColor: "#edf1f6",
            }}
        >
            <div className="d-flex row  w-100 m-0 mb-5">
                <Helmet>
                    <title>Influencer Approval</title>
                </Helmet>
                <div
                    component="nav"
                    sx={{
                        width: "100%", // Take full width on mobile
                    }}
                    aria-label="maildiv folders"
                >
                    <Drawer
                        container={container}
                        variant="temporary"
                        open={mobileOpen}
                        onClose={handleDrawerToggle}
                        ModalProps={{
                            keepMounted: true,
                        }}
                        sx={{
                            "& .MuiDrawer-paper": {
                                width: "280px", // Adjust width for mobile
                                backgroundColor: "white",
                                color: "#727376",
                            },
                        }}
                    >
                        <div className="d-flex flex-column h-100" style={{overflowY: "hidden"}}>
                            <SidebarMenuList />
                        </div>
                    </Drawer>
                </div>
                {isLoginModalOpen && (
                    <LoginPopUp
                        isLoginModalOpen={isLoginModalOpen}
                        setLoginModalOpen={setLoginModalOpen} // Pass the state setter down
                        onClose={handleModalClose}
                    />
                )}
                <Header3 />
                <div className="profile-section col" style={{maxWidth: "100%"}}>
                    <div className="profile-container  profile-container-lg">
                        {/* Profile tabs */}
                        <div className="d-flex justify-content-between my-5">
                            {mediaQueryVar ? (
                                <>
                                    <div
                                        style={{
                                            position: "fixed",
                                            top: 0,
                                            left: drawerWidth,
                                            width: `calc(100% - ${drawerWidth}px)`,
                                            backgroundColor: "#ffffff",
                                            zIndex: 1000,
                                            divShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                            height: "100px", // You may need to increase this if banner + nav exceeds 100px
                                            display: "flex",
                                            flexDirection: "column",
                                        }}
                                    >
                                        <PromoBanner />

                                        <TopNavigationDesktop unreadAlerts={unreadAlerts} />
                                    </div>
                                </>
                            ) : (
                                <div
                                    style={{
                                        position: "fixed",
                                        top: 0,
                                        left: 0, // aligns it to the right of the sidebar
                                        width: "100%", // takes full width minus sidebar
                                        backgroundColor: "#ffffff",
                                        zIndex: 1000,
                                        divShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                        height: "100px",
                                        display: "flex",
                                        flexDirection: "column",
                                    }}
                                >
                                    <PromoBanner />
                                    <TopNavigationMobile unreadAlerts={unreadAlerts} />
                                </div>
                            )}
                        </div>
                        <div style={{marginTop: mediaQueryVar ? "150px" : "120px"}}>
                            <InfluencerApproval />
                            {/* <DaoApprovalPanel/> */}
                        </div>

                        {goToSubscribeAlertOpen && (
                            <GoToSubscribeAlert onClose={setGoToSubscribeAlertOpen} text={subscriptionText} />
                        )}
                        <GoogleLoginHandler redirectUrl={location.pathname} />
                    </div>
                </div>
            </div>
        </div>
    );
};
